<template>
    <div
        class="users-page container-fluid page-card admin-weflix-users"
        data-aos="fade-left"
        data-aos-duration="1500"
    >
        <div class="users-tabs-card">
            <div class="users-toolbar" role="banner">
                <div class="users-toolbar__lead">
                    <h2 class="users-toolbar__title">Usuários</h2>
                    <p class="users-toolbar__subtitle">
                        Gerencie os usuários do sistema.
                    </p>
                </div>
                <div class="users-toolbar__actions">
                    <button
                        type="button"
                        class="btnExport usersExport"
                        @click="exportarUsuariosParaCSV"
                        :disabled="isExporting"
                    >
                        <fa icon="fa-download" />
                        <LoaderImage v-show="isExporting" />
                    </button>
                    <button
                        type="button"
                        class="btnExport btnExport--primary"
                        @click="() => this.$router.push('/admin/novo-usuario')"
                    >
                        <fa icon="fa fa-plus"></fa>
                        <span class="btnExport__text">Novo Usuário</span>
                    </button>
                </div>
            </div>
        </div>

        <div class="users-shell">
            <div class="users-stack">
                <div class="users-subpanel users-subpanel--stats">
        <!-- Stats Cards Section -->
        <div class="stats-section">
            <div class="stats-grid">
                <div class="stat-card stat-card--primary">
                    <div class="stat-card__content">
                        <h3 v-if="hasReadyStats">
                            {{ totalUsers.toLocaleString('pt-BR') }}
                        </h3>
                        <LoaderImage v-if="!hasReadyStats" />
                        <p v-if="hasReadyStats">Usuários Cadastrados</p>
                    </div>
                </div>
                <div class="stat-card stat-card--progress">
                    <div class="stat-card__content">
                        <div class="stat-card__progress-content">
                            <div class="stat-card__header">
                                <strong v-if="hasReadyStats">
                                    {{ percentageSubscribers.toFixed(2) }}%
                                </strong>
                                <LoaderImage v-if="!hasReadyStats" />
                                <small v-if="hasReadyStats">
                                    Assinantes ({{ totalSubscribers }})
                                </small>
                            </div>
                            <div class="stat-card__progress" v-if="hasReadyStats">
                                <div class="progress-bar">
                                    <div
                                        class="progress animate-progress"
                                        :style="{
                                            width: percentageSubscribers + '%',
                                        }"
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="stat-card stat-card--progress">
                    <div class="stat-card__content">
                        <div class="stat-card__progress-content">
                            <div class="stat-card__header">
                                <strong v-if="hasReadyStats">
                                    {{ Math.floor(percentageAdmins) }}%
                                </strong>
                                <LoaderImage v-if="!hasReadyStats" />
                                <small v-if="hasReadyStats">
                                    Gestores ({{ totalAdmins }})
                                </small>
                            </div>
                            <div class="stat-card__progress" v-if="hasReadyStats">
                                <div class="progress-bar">
                                    <div
                                        class="progress animate-progress"
                                        :style="{
                                            width: percentageAdmins + '%',
                                        }"
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="stat-card stat-card--progress">
                    <div class="stat-card__content">
                        <div class="stat-card__progress-content">
                            <div class="stat-card__header">
                                <strong v-if="hasReadyStats">
                                    {{ Math.floor(percentageActives) }}%
                                </strong>
                                <LoaderImage v-if="!hasReadyStats" />
                                <small v-if="hasReadyStats">
                                    Ativos ({{ totalActives.toLocaleString('pt-BR') }})
                                </small>
                            </div>
                            <div class="stat-card__progress" v-if="hasReadyStats">
                                <div class="progress-bar">
                                    <div
                                        class="progress animate-progress"
                                        :style="{
                                            width: percentageActives + '%',
                                        }"
                                    ></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
                </div>

                <div class="users-subpanel users-subpanel--filters">
                    <div class="users-filters">
                        <div
                            class="users-filters__grid"
                            id="searchUserPage"
                            role="search"
                        >
                            <div class="users-filter-field">
                                <label class="users-filter-label" for="filter-order-status">
                                    Assinatura
                                </label>
                                <select
                                    id="filter-order-status"
                                    v-model="orderFilter"
                                    class="form-select filter-users"
                                >
                                    <option value="">Todos</option>
                                    <option value="1">Assinante</option>
                                    <option value="0">Não assinante</option>
                                </select>
                            </div>
                            <div class="users-filter-field">
                                <label class="users-filter-label" for="filter-user-type">
                                    Tipo de conta
                                </label>
                                <select
                                    id="filter-user-type"
                                    v-model="typeFilter"
                                    class="form-select filter-users"
                                >
                                    <option value="">Todos</option>
                                    <option value="2">Gestor</option>
                                    <option value="3">Usuário</option>
                                </select>
                            </div>
                            <div class="users-filter-field users-filter-field--search">
                                <label class="users-filter-label" for="userSearchInput">
                                    Nome ou e-mail
                                </label>
                                <div class="form-input search-input-user">
                                    <input
                                        id="userSearchInput"
                                        type="search"
                                        class="form-control search-input-user"
                                        placeholder="Digite para buscar…"
                                        v-model="userSearch"
                                        autocomplete="off"
                                        @keydown.enter.prevent="getUserByName"
                                    />
                                    <fa icon="fa-magnifying-glass" />
                                </div>
                            </div>
                            <div class="users-filter-field users-filter-field--actions">
                                <span
                                    class="users-filter-label users-filter-label--phantom"
                                    aria-hidden="true"
                                    >&nbsp;</span
                                >
                                <div class="users-filter-actions">
                                    <button
                                        type="button"
                                        class="btnSearch"
                                        id="btnSearchUserPage"
                                        @click="getUserByName"
                                    >
                                        Buscar
                                    </button>
                                    <button
                                        type="button"
                                        class="btnClear"
                                        @click="clearSearch"
                                        v-if="
                                            userSearch?.length > 0 ||
                                            orderFilter ||
                                            typeFilter
                                        "
                                    >
                                        Limpar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="users-subpanel users-subpanel--table">
        <!-- Table Section -->
        <div class="table-section">
            <v-table class="custom-table">
                <thead>
                    <tr>
                        <th class="table-header">
                            <span>Nome</span>
                        </th>
                        <th class="table-header">
                            <span>E-mail</span>
                            <i
                                :class="[
                                    'fas',
                                    ordemAtual === 'speed'
                                        ? ordemAscendente
                                            ? 'fa-sort-up'
                                            : 'fa-sort-down'
                                        : 'fa-sort',
                                ]"
                            ></i>
                        </th>
                        <th class="table-header">Assinante</th>
                        <th class="table-header">Tipo</th>
                        <th class="table-header text-center">Pagamentos</th>
                        <th class="table-header text-center">Editar</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(user, index) in usuariosFiltrados" :key="index">
                        <td class="tableUserName">{{ user.name }}</td>
                        <td>{{ user.email }}</td>
                        <td>
                            <span
                                :class="{
                                    'badge badge--success':
                                        user.orderStatus == 1,
                                    'badge badge--info': user.orderStatus == 4,
                                    'badge badge--default':
                                        user.orderStatus != 1 &&
                                        user.orderStatus != 4,
                                }"
                            >
                                {{
                                    user.orderStatus == 1
                                        ? 'Assinante'
                                        : user.orderStatus == 4
                                        ? 'Compra Avulsa'
                                        : 'Não Assinante'
                                }}
                            </span>
                        </td>
                        <td>
                            <span
                                :class="{
                                    'badge badge--primary': user.type == 2,
                                    'badge badge--default': user.type == 3,
                                }"
                            >
                                {{
                                    user.type == 1
                                        ? 'Administrador'
                                        : user.type == 2
                                        ? 'Gestor'
                                        : 'Usuário'
                                }}
                            </span>
                        </td>
                        <td class="text-center">
                            <v-btn
                                icon="mdi-currency-usd"
                                color="heading"
                                variant="text"
                                title="Ver pagamentos"
                                @click="
                                    () =>
                                        this.$router.push(
                                            `pagamentos-usuario/${user.id}`
                                        )
                                "
                            >
                            </v-btn>
                        </td>
                        <td class="text-center">
                            <v-btn
                                icon="mdi-pencil"
                                color="heading"
                                variant="text"
                                title="Editar usuário"
                                @click="
                                    () =>
                                        this.$router.push(
                                            `editar-usuario/${user.id}`
                                        )
                                "
                            >
                            </v-btn>
                        </td>
                    </tr>
                    <tr v-if="usuariosFiltrados.length === 0 && hasReady">
                        <td colspan="6" class="table-empty">
                            Nenhum usuário encontrado
                        </td>
                    </tr>
                </tbody>
            </v-table>
        </div>

        <!-- Pagination Section -->
        <div class="pagination-section">
            <v-responsive>
                <v-pagination
                    v-model="paginaAtual"
                    :length="paginasTotais"
                    :total-visible="5"
                    :disabled="!hasReady"
                    :start="0"
                    @update:model-value="getUsers"
                ></v-pagination>
            </v-responsive>
        </div>

        <!-- Loaders -->
        <Loader v-if="!hasReady" />
        <LoaderImage v-if="!hasReadySearch" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import User from '@/utils/Weflix/user';
    import { mapState } from 'vuex';
    import { toast } from 'vue3-toastify';
    import Loader from '@/components/Weflix/Loader';
    import LoaderImage from '@/components/Weflix/LoaderImage.vue';
    export default {
        components: {
            Loader,
            LoaderImage,
        },
        data() {
            return {
                users: [],
                usuariosFiltrados: [],
                ordemAtual: 'name',
                ordemAscendente: true,
                hasReady: false,
                userSearch: null,
                orderFilter: '',
                typeFilter: '',
                totalUsers: 0,
                totalSubscribers: 0,
                percentageSubscribers: 0,
                totalAdmins: 0,
                percentageAdmins: 0,
                totalActives: 0,
                percentageActives: 0,
                paginaAtual: 0,
                porPagina: 10,
                paginasTotais: 0,
                carregando: false,
                temMaisUsuarios: true,
                hasReadyStats: false,
                hasReadySearch: true,
                exportUsers: [],
                isExporting: false,
            };
        },
        computed: {
            ...mapState(['token']),
        },
        created() {
            this.getUsers();
            this.getUserStats();
        },
        methods: {
            ordenar(coluna) {
                // Se clicar na mesma coluna, inverte a ordem
                if (this.ordemAtual === coluna) {
                    this.ordemAscendente = !this.ordemAscendente;
                } else {
                    // Se clicar em uma nova coluna, ordena ascendente
                    this.ordemAtual = coluna;
                    this.ordemAscendente = true;
                }

                // Ordena os usuários, excluindo type 1
                this.usuariosFiltrados = this.usuariosFiltrados.filter(
                    (user) => user.type !== 1
                );
                this.usuariosFiltrados.sort((a, b) => {
                    let comparacao = 0;
                    if (a[coluna] < b[coluna]) comparacao = -1;
                    if (a[coluna] > b[coluna]) comparacao = 1;
                    return this.ordemAscendente ? comparacao : -comparacao;
                });
            },
            async getUsers() {
                const payload = {
                    type: this.typeFilter || null,
                    order: this.orderFilter || null,
                };
                try {
                    this.hasReady = false;

                    const response = await User.getAllUserWithPurchase(
                        this.token,
                        this.paginaAtual,
                        this.porPagina,
                        payload
                    );
                    if (response && response.content) {
                        if (response.content.length === 0) {
                            this.temMaisUsuarios = false;
                            return;
                        }
                        const filteredContent = response.content.filter(
                            (user) => user.type !== 1
                        );
                        this.users = [...this.users, ...filteredContent];
                        this.usuariosFiltrados = [...filteredContent];
                        this.paginasTotais = response.totalPages;
                    }
                } catch (error) {
                    toast.error('Erro ao carregar usuários');
                } finally {
                    this.hasReady = true;
                }
            },
            async getAllUserExport() {
                try {
                    const response = await User.getAllUserExport(this.token);
                    this.exportUsers = response.content;
                    this.isExporting = false;
                } catch (error) {
                    console.error('Erro ao obter usuários:', error);
                }
            },
            async getUserStats() {
                this.hasReadyStats = false;

                try {
                    const response = await User.getUserStats(this.token);
                    this.totalUsers = response.totalUsers;
                    this.totalSubscribers = response.totalSubscribers;
                    this.percentageSubscribers = response.percentageSubscribers;
                    this.totalAdmins = response.totalAdmins;
                    this.percentageAdmins = response.percentageAdmins;
                    this.totalActives = response.totalActives;
                    this.percentageActives = response.percentageActives;
                    this.hasReadyStats = true;
                } catch (error) {
                    console.error(
                        'Erro ao obter dados das estatísticas do usuário:',
                        error
                    );
                }
            },
            async getUserByName() {
                if (this.userSearch) {
                    if (
                        this.userSearch.length < 3 &&
                        !this.typeFilter &&
                        !this.orderFilter
                    ) {
                        this.getUsers();
                        return;
                    }
                }

                this.hasReadySearch = false;
                const payload = {
                    name: this.userSearch || null,
                    type: this.typeFilter || null,
                    order: this.orderFilter || null,
                };
                try {
                    const response = await User.getUserByName(
                        this.token,
                        payload
                    );
                    if (response.content && Array.isArray(response.content)) {
                        this.usuariosFiltrados = response.content;
                        this.users = response.content;
                        this.hasReadySearch = true;
                    } else {
                        this.usuariosFiltrados = [];
                        this.users = [];
                        this.hasReadySearch = true;
                    }
                } catch (error) {
                    console.error('Erro ao obter usuário pelo nome:', error);
                    this.usuariosFiltrados = [];
                    this.users = [];
                    this.hasReadySearch = true;
                }
            },
            clearSearch() {
                this.userSearch = '';
                this.orderFilter = '';
                this.typeFilter = '';
                this.users = [];
                this.usuariosFiltrados = [];
                this.paginaAtual = 0;
                this.temMaisUsuarios = true;
                this.getUsers();
            },

            async exportarUsuariosParaCSV() {
                if (this.isExporting) return;

                try {
                    this.isExporting = true;

                    await this.getAllUserExport();

                    if (!this.exportUsers || this.exportUsers.length === 0) {
                        console.error('Nenhum usuário para exportar');
                        return;
                    }

                    const cabecalho = [
                        'ID',
                        'Nome',
                        'E-mail',
                        'Telefone',
                        'Tipo',
                        'Status',
                        'CPF',
                        'RG',
                        'País',
                        'Estado',
                        'Cidade',
                        'Endereço',
                        'Bairro',
                        'Número',
                        'Complemento',
                        'CEP',
                        'Data de Inserção',
                        'Primeiro Login',
                        'Ativo',
                    ];
                    const linhasCSV = Array.isArray(this.exportUsers)
                        ? this.exportUsers.map((user) => [
                              user.id,
                              user.name,
                              user.email,
                              user.phone,
                              user.type,
                              user.statusDescription,
                              user.socialNumber,
                              user.idNumber,
                              user.country,
                              user.county,
                              user.city,
                              user.address,
                              user.neighborhood,
                              user.addressNumber,
                              user.addressComplement,
                              user.postcode,
                              user.dateInsert,
                              user.firstLogin ? 'Sim' : 'Não',
                              user.enabled ? 'Sim' : 'Não',
                          ])
                        : [];

                    const conteudoCSV = [
                        cabecalho.join(','),
                        ...linhasCSV.map((linha) => linha.join(',')),
                    ].join('\n');

                    const blob = new Blob(['\ufeff' + conteudoCSV], {
                        type: 'text/csv;charset=utf-8;',
                    });
                    const link = document.createElement('a');
                    const url = URL.createObjectURL(blob);

                    link.setAttribute('href', url);
                    link.setAttribute(
                        'download',
                        `usuarios_weflix_${new Date().toLocaleDateString()}.csv`
                    );
                    link.style.visibility = 'hidden';

                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
                } catch (error) {
                    console.error('Erro ao exportar usuários:', error);
                } finally {
                    this.isExporting = false;
                }
            },
        },
    };
</script>

<style scoped>
    @import url(./global.css);

    .users-page.container-fluid.page-card {
        max-width: 100%;
        background: #f4f5f8;
        border-radius: 16px;
        padding: 0 0 1rem;
        box-shadow: 0 1px 3px rgba(37, 8, 145, 0.06);
    }

    .users-tabs-card {
        padding: 1rem;
    }

    /* Mesmo ritmo visual de .payments-tabs / .settings-tabs */
    .users-toolbar {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        padding: 0.75rem 1rem;
        background: #fff;
        border: 1px solid #e8eaf0;
        border-radius: 14px;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
    }

    .users-toolbar__lead {
        min-width: 0;
        flex: 1 1 200px;
        text-align: left;
    }

    .users-toolbar__title {
        margin: 0;
        font-family:
            Inter,
            system-ui,
            -apple-system,
            sans-serif;
        font-size: 1.125rem;
        font-weight: 600;
        line-height: 1.3;
        color: #1a1d26;
    }

    .users-toolbar__subtitle {
        margin: 0.25rem 0 0 0;
        font-family:
            Inter,
            system-ui,
            -apple-system,
            sans-serif;
        font-size: 0.875rem;
        line-height: 1.45;
        color: #6b7280;
    }

    .users-toolbar__actions {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        align-items: center;
        flex-shrink: 0;
    }

    .users-shell {
        padding: 0 1.5rem 1.5rem;
        height: calc(100vh - 210px);
        overflow-y: auto;
        min-height: 0;
        box-sizing: border-box;
        scrollbar-width: none;
        -ms-overflow-style: none;
    }

    .users-shell::-webkit-scrollbar {
        display: none;
    }

    .users-stack {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        width: 100%;
        max-width: 100%;
    }

    .users-subpanel {
        background: #fff;
        border: 1px solid #e8eaf0;
        border-radius: 14px;
        padding: 1.25rem 1.35rem 1.5rem;
        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
        min-height: 0;
    }

    .users-subpanel--filters {
        padding-top: 1.1rem;
        padding-bottom: 1.1rem;
    }

    .users-subpanel--stats {
        padding-top: 1.1rem;
        padding-bottom: 1.25rem;
    }

    /* Buttons */
    .btnExport {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        height: 38px;
        padding: 6px 12px;
        background-color: white;
        border: 1px solid #250891;
        color: #250891;
        border-radius: 5px;
        font-size: 14px;
        cursor: pointer;
        transition: all 300ms ease-in-out;
        white-space: nowrap;
    }

    .btnExport:hover:not(:disabled) {
        background-color: #250891;
        color: white;
    }

    .btnExport:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }

    .btnExport--primary {
        background-color: #250891;
        color: white;
    }

    .btnExport--primary:hover {
        background-color: #1a0668;
    }

    .btnExport__text {
        display: none;
    }

    @media (min-width: 768px) {
        .btnExport__text {
            display: inline;
        }
    }

    .btnExport svg {
        color: inherit;
    }

    button.btnExport.usersExport {
        display: inline-flex;
    }

    button.btnExport.usersExport .loader2 {
        width: 19px;
        aspect-ratio: 1;
        border-radius: 50%;
        border: 2px solid #250891;
        animation: l20-1-79f4614c 0.8s infinite linear alternate,
            l20-2-79f4614c 1.6s infinite linear;
        margin: 0px 10px;
        position: initial;
    }

    /* Filters */
    .users-subpanel--filters {
        padding-top: 1.1rem;
        padding-bottom: 1.15rem;
    }

    .users-filters {
        text-align: left;
    }

    .users-filters__grid {
        display: grid;
        grid-template-columns: minmax(0, 160px) minmax(0, 160px) minmax(
                200px,
                1fr
            )
            auto;
        gap: 1rem 1.25rem;
        align-items: end;
    }

    .users-filter-field {
        min-width: 0;
        text-align: left;
    }

    .users-filter-field--search {
        min-width: 0;
    }

    .users-filter-label {
        display: block;
        width: 100%;
        margin-bottom: 0.4rem;
        font-size: 0.8125rem;
        font-weight: 600;
        color: #374151;
        line-height: 1.2;
        text-align: left;
    }

    .users-filter-label--phantom {
        visibility: hidden;
        user-select: none;
    }

    .users-filter-actions {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 10px;
    }

    .form-select,
    .form-control {
        height: 40px;
        padding: 0 12px;
        border: 1px solid #e8eaf0;
        border-radius: 10px;
        font-size: 14px;
        color: #1f2937;
        background-color: #fff;
        width: 100%;
        transition:
            border-color 0.2s ease,
            box-shadow 0.2s ease;
    }

    .form-select {
        cursor: pointer;
        appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236b7280' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 12px center;
        padding-right: 36px;
        max-width: none;
    }

    .form-select:hover,
    .form-control:hover {
        border-color: #cfd6e4;
    }

    .form-select:focus,
    .form-control:focus {
        outline: none;
        border-color: #250891;
        box-shadow: 0 0 0 3px rgba(37, 8, 145, 0.12);
    }

    .form-input.search-input-user {
        position: relative;
        margin: 0;
        width: 100%;
    }

    .form-input.search-input-user input.form-control {
        width: 100%;
        max-width: 100%;
        padding-right: 40px;
    }

    .form-input.search-input-user
        :deep(svg.svg-inline--fa.fa-magnifying-glass) {
        position: absolute;
        right: 14px;
        top: 50%;
        transform: translateY(-50%);
        color: #9ca3af;
        pointer-events: none;
        font-size: 14px;
    }

    .form-control.search-input-user::placeholder {
        color: #9ca3af;
    }

    .btnSearch,
    .btnClear {
        height: 40px;
        padding: 0 16px;
        border-radius: 10px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition:
            background-color 0.2s ease,
            color 0.2s ease,
            border-color 0.2s ease;
        white-space: nowrap;
    }

    .btnSearch {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #250891;
        background-color: #250891;
        color: #fff;
    }

    .btnSearch:hover {
        background-color: #1a0668;
        border-color: #1a0668;
        color: #fff;
    }

    .btnClear {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #e8eaf0;
        background-color: #fff;
        color: #4b5563;
    }

    .btnClear:hover {
        border-color: #250891;
        color: #250891;
        background-color: #f8f7fc;
    }

    /* Stats Section */
    .stats-section {
        margin: 0;
    }

    .users-subpanel--stats .stat-card {
        background: #f4f6fa;
        border: 1px solid #e8eaf0;
        box-shadow: none;
    }

    .stats-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 16px;
    }

    .stat-card {
        padding: 20px;
        box-shadow: -1px 4px 10px 1px #dfdfdf;
        border-radius: 5px;
        background-color: white;
        min-height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .stat-card__content {
        width: 100%;
        text-align: center;
    }

    .stat-card__content h3 {
        font-size: 28px;
        font-weight: 700;
        margin: 0 0 8px 0;
        color: #250891;
    }

    .stat-card__content p {
        font-size: 14px;
        color: #666;
        margin: 0;
    }

    .stat-card--progress .stat-card__content {
        text-align: left;
    }

    .stat-card__progress-content {
        width: 100%;
    }

    .stat-card__header {
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        margin-bottom: 8px;
    }

    .stat-card__header strong {
        font-size: 24px;
        font-weight: 700;
        color: #250891;
    }

    .stat-card__header small {
        font-size: 12px;
        color: #666;
    }

    .stat-card__progress {
        margin-top: 8px;
    }

    .progress-bar {
        width: 100%;
        background-color: #e0e0e0;
        border-radius: 10px;
        overflow: hidden;
        height: 8px;
        position: relative;
    }

    .progress {
        height: 100%;
        background-color: #250891;
        border-radius: 10px;
        transition: width 0.3s ease;
    }

    .animate-progress {
        animation: progressAnimation 2s ease-out forwards;
    }

    @keyframes progressAnimation {
        from {
            width: 0;
        }
    }

    /* Table Section */
    .table-section {
        margin: 0 0 0.75rem;
        overflow-x: auto;
    }

    .table-header {
        font-weight: 600;
        color: #333;
        vertical-align: middle;
    }

    .table-header i {
        color: #999;
        font-size: 12px;
        margin-left: 8px;
        vertical-align: middle;
    }

    .tableUserName {
        min-width: 150px;
        font-weight: 500;
    }

    .table-empty {
        text-align: center;
        padding: 40px;
        color: #999;
    }

    /* Badges */
    .badge {
        display: inline-block;
        padding: 4px 12px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 500;
    }

    .badge--success {
        background-color: #d4edda;
        color: #155724;
    }

    .badge--info {
        background-color: #d1ecf1;
        color: #0c5460;
    }

    .badge--primary {
        background-color: #cce5ff;
        color: #004085;
    }

    .badge--default {
        background-color: #e2e3e5;
        color: #383d41;
    }

    /* Pagination Section */
    .pagination-section {
        margin: 0;
        padding-top: 0.5rem;
        display: flex;
        justify-content: center;
    }

    :deep(.v-pagination__list) {
        padding-left: 0;
    }

    /* Responsive */
    @media (max-width: 768px) {
        .users-shell {
            padding: 0 1rem 1.25rem;
        }

        .users-subpanel {
            padding: 1rem;
        }

        .users-toolbar {
            padding: 0.75rem 0.85rem;
        }

        .users-toolbar__lead {
            flex: 1 1 100%;
        }

        .users-toolbar__actions {
            width: 100%;
            justify-content: flex-start;
        }

        .users-filters__grid {
            grid-template-columns: 1fr 1fr;
        }

        .users-filter-field--search,
        .users-filter-field--actions {
            grid-column: 1 / -1;
        }

        .users-filter-label--phantom {
            display: none;
        }

        .users-filter-actions {
            width: 100%;
        }

        .btnSearch,
        .btnClear {
            flex: 1;
            min-width: 0;
        }

        .stats-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 12px;
        }

        .stat-card {
            min-height: 100px;
            padding: 16px;
        }

        .stat-card__content h3 {
            font-size: 20px;
        }

        .stat-card__header strong {
            font-size: 20px;
        }
    }

    @media (max-width: 560px) {
        .users-filters__grid {
            grid-template-columns: 1fr;
        }

        .users-filter-field--search,
        .users-filter-field--actions {
            grid-column: auto;
        }
    }

    @media (max-width: 480px) {
        .stats-grid {
            grid-template-columns: 1fr;
        }

        .btnExport__text {
            display: none;
        }
    }
</style>
